import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { FlagTransparentIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { useDeclareVictory } from './hooks';

export const DeclareVictory: React.FC = () => {
	const {
		data: { declareVictoryLink },
		actions: { handleDeclareVictory },
	} = useDeclareVictory();

	return (
		<>
			<div className="flex w-full flex-col">
				<Text className="mt-6" size="x-small" variant="heading">
					<Translate value="corgi.petition.edit.settings.declare_victory.button" />
				</Text>
				<Text className="mt-3" variant="body" size="medium">
					<Translate value="corgi.petition.edit.settings.declare_victory.description" />
				</Text>
			</div>
			<div>
				<Button
					className="w-56 sm:mt-4 md:mt-8"
					leadingIcon={<FlagTransparentIcon />}
					variant="primary"
					size="small"
					data-qa="declare-victory-button"
					onClick={handleDeclareVictory}
					as="a"
					href={declareVictoryLink}
				>
					<Translate value="corgi.petition.edit.settings.declare_victory.button" />
				</Button>
			</div>
		</>
	);
};
